// extracted by mini-css-extract-plugin
export default {"container":"ShellLanguage_container__vl1FK","subtitle":"ShellLanguage_subtitle__6E0Oa","select":"ShellLanguage_select__UaUK7"};